// src/utils/statusColors.js
// Colores y variantes para estados de asistentes - Sistema Unificado

import { theme } from "../theme";
import { ATTENDEE_STATES } from "../constants/attendeeStates";

// Mapeo de colores por estado usando constantes centralizadas
export const statusColors = {
  [ATTENDEE_STATES.ATTENDING]: theme.palette.chateauGreen[500], // Verde para confirmado
  [ATTENDEE_STATES.CONFIRMATION_PENDING]: theme.palette.mediumPurple[500], // Morado para pendiente
  [ATTENDEE_STATES.NOT_ATTENDING]: theme.colors.defaultWeak, // Gris para no asistirá
  [ATTENDEE_STATES.CANCELLATION_PENDING]: theme.palette.internationalOrange[400], // Naranja para cancelación pendiente
  [ATTENDEE_STATES.CANCELLED_BY_USER]: theme.colors.defaultWeak, // Gris para cancelado por usuario
  [ATTENDEE_STATES.CANCELLED_BY_ORGANIZER]: theme.colors.defaultWeak, // Gris para cancelado por organizador
  [ATTENDEE_STATES.REJECTED_BY_ORGANIZER]: theme.palette.redOrange[500], // Rojo para rechazado
  [ATTENDEE_STATES.REFUND_ACCEPTED]: theme.palette.mediumPurple[400], // Morado claro para reembolso aceptado
  [ATTENDEE_STATES.REFUNDED]: theme.palette.mediumPurple[400], // Morado claro para reembolsado
};

// Mapeo de variantes de tag por estado usando constantes centralizadas
export const statusTagVariants = {
  [ATTENDEE_STATES.ATTENDING]: 'attending',
  [ATTENDEE_STATES.CONFIRMATION_PENDING]: 'confirmationPending',
  [ATTENDEE_STATES.NOT_ATTENDING]: 'danger',
  [ATTENDEE_STATES.CANCELLATION_PENDING]: 'subtle',
  [ATTENDEE_STATES.CANCELLED_BY_USER]: 'rejected',
  [ATTENDEE_STATES.CANCELLED_BY_ORGANIZER]: 'rejected',
  [ATTENDEE_STATES.REJECTED_BY_ORGANIZER]: 'rejected',
  [ATTENDEE_STATES.REFUND_ACCEPTED]: 'subtle',
  [ATTENDEE_STATES.REFUNDED]: 'subtle'
};
